import { render, staticRenderFns } from "./CoinsTitleSeparate.vue?vue&type=template&id=97bdcdee&scoped=true&"
import script from "./CoinsTitleSeparate.vue?vue&type=script&lang=ts&"
export * from "./CoinsTitleSeparate.vue?vue&type=script&lang=ts&"
import style0 from "./CoinsTitleSeparate.vue?vue&type=style&index=0&id=97bdcdee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bdcdee",
  null
  
)

export default component.exports